import React from 'react';
import { useSelector } from 'react-redux';

import { ApiRequestStatus } from '@makemydeal/dr-shared-types';

// store
import { getSelectedDealTypes, getSelectedIncentives, getNotes, getRequestStatus } from '../../store';

// components
import PaymentOptionsSection from '../PaymentOptionsSection/PaymentOptionsSection';
import IncentivesSection from '../IncentivesSection/IncentivesSection';
import NotesSection from '../NotesSection/NotesSection';
import SendRequestButton from '../SendRequestButton/SendRequestButton';
import { PageHeader } from '@makemydeal/dr-sales-checkin-components';

// styles
import { RequestProposalContainer } from './RequestProposal.styles';
import { useRequestProposalActions } from '../../hook/useRequestProposalActions';

const RequestProposal: React.FC = () => {
    const selectedDealTypes = useSelector(getSelectedDealTypes);
    const selectedIncentives = useSelector(getSelectedIncentives);
    const notes = useSelector(getNotes);
    const requestStatus = useSelector(getRequestStatus);

    const { handleToggleDealType, handleToggleIncentive, handleNotesChange, onSendRequestClick } = useRequestProposalActions();

    return (
        <RequestProposalContainer data-testid="request-proposal-page">
            <PageHeader isResponsive heading="Deal Summary" />
            <PaymentOptionsSection selectedDealTypes={selectedDealTypes} onToggle={handleToggleDealType} />
            <IncentivesSection selectedIncentives={selectedIncentives} onToggle={handleToggleIncentive} />
            <NotesSection notes={notes} onChange={handleNotesChange} />
            <SendRequestButton isSubmitting={requestStatus === ApiRequestStatus.Loading} onClick={onSendRequestClick} />
        </RequestProposalContainer>
    );
};

export default RequestProposal;
